import reducer from './reducers';

export { default as floorLayoutOperations } from './operations';
export { default as floorLayoutSelectors } from './selectors';
export { default as floorLayoutSagas } from './sagas';
export { default as floorLayoutTypes } from './types';

export default reducer;
